<template>
    <div class="relative" >        
        <div class="container" >
            <div class="col-md-9 col-sm-12 mx-auto">
                <div class="flex j-c-center content">
                <div id="scrollForms">
                    <h2 class="color-white text-center show-desktop">Seu negócio com <strong >milhares de clientes mensalmente</strong> sendo atendidos por um catálogo de mais de <strong>1.000 serviços digitais e financeiros.</strong> </h2>
                    <h2 class="color-white show-mobile text-center ">
                        <strong>Milhares de clientes mensalmente</strong><br>
                        sendo <br> atendidos por um catálogo <br> de mais de <br>
                        <strong>1.000 serviços digitais e financeiros.</strong>
                    </h2>
                    <br>
                    <h2 class="text-center">
                        <strong class="color-white">Não perca tempo!</strong>
                    </h2>
                </div>
            </div>
            <form @submit.prevent="onSubmit" class="relative" id="form">
                <div class="sendigSvg" v-show="svgSending">
                    <img class="img-responsive" src="@/lib/SVG-Loaders-master/ball-triangle.svg" alt="ball-triangle">
                </div>
                <div class="row">
                    <div class="col-md-6" v-for="(item, index) in labelsForms" :key="index">
                        <div class="text-center">
                            <label class="color-white" :for="item.label" :type="item.type" v-html="item.content"></label>
                        </div>
                        <div v-if="item.mask != undefined">
                            <input :id="item.id" :type="item.type" v-model="item.vmodel" required v-mask="item.mask" :placeholder="item.placeholder">
                        </div>
                        <div v-else>
                            <input :id="item.id" :type="item.type" v-model="item.vmodel" required :placeholder="item.placeholder">
                        </div>
                    </div>
                    <!-- <div class="col-md-12">
                        <div class="text-center">
                            <label class="color-white" for="">Como ficou sabendo do <strong>Ponto Fácil</strong></label>
                        </div>
                        <div>
                            <input id="comoSoube" type="text" required placeholder="Como ficou sabendo da Ponto Fácil?">
                        </div>
                        <div class="text-center">
                            <label class="ddd color-white" for="">Conte mais <strong>sobre você e sua ideia de negócio</strong> com a Ponto Fácil.</label>
                        </div>
                        <div>
                            <textarea name="" id="SuaIdea" cols="30" rows="10" min="50" required v-model="YourIdea"></textarea>
                        </div>
                    </div> -->
                    <button type="submit" class="color-white f-w-700 bg-color-175D93" id="btnReset">{{btnText}}</button>
                </div>
            </form>
                
            </div>
        </div>
    </div>
</template>

<style scoped>
    
    input, textarea, button{
        width: 100%;
        border: none;
        height: 40px;
        border-radius: 50px;
    }

    input::-webkit-input-placeholder, textarea::-webkit-input-placeholder{
        color: rgba(53, 126, 184, .5);
    }

    input::-moz-placeholder, textarea::-moz-placeholder{
        color: rgba(53, 126, 184, .5);
    }

    input:-ms-input-placeholder, textarea:-ms-input-placeholder{
        color: rgba(53, 126, 184, .5);
    }

    input::placeholder, textarea::placeholder{
        color: rgba(53, 126, 184, .5);
    }

    button{
        margin-top: 25px;
    }

    button:hover{
        cursor: pointer
    }

    textarea{
        height: 300px;
        color: #357EB8;
        padding: 10px 20px
    }

    .content > div{
        width: 75%
    }

    .content{
        padding-top: 400px;
    }

    form{
        margin-top: 50px;
    }

    label{
        margin: 0 0 20px 0;
    }

    h2{
        line-height: 1.25!important
    }

    .ddd{
        margin-top: 20px;
    }

    .opinions{       
        width: 100%;
    }

    .opinions > div{
        width:20%;
        right: 0px;
        bottom: 50px;
    }

    form{
        padding-bottom: 150px
    }

    h2.show-desktop{
        display: block!important
    }

    form input, textarea{
        background-color: #fff;
    }

    @media only screen and (max-width: 1024px){
        .opinions > div{
            right: 25px!important;
            bottom: -120px
        }
    }

    @media only screen and (max-width: 767px){
        .show-mobile{
            display: block!important;
        }
        h2.show-desktop{
            display: none!important
        }
        form{
            padding-bottom: 80px;
        }        
    } 

    @media only screen and (max-width: 360px){

        .content{
            padding-top: 490px;
        }
    }

</style>
<script>

</script>

<script>
import $ from 'jquery'
import { mask } from 'vue-the-mask'
import PublicOpinion from '@/components/PublicOpinion.vue'
export default {
    directives: {
      mask,
    },
    data() {
        return {
            btnText:'Quero ter uma franquia agora!',
            Profession:'',
            Borned:'',
            city:'',
            HowMutch:'',
            AreABusinessperson:'',   
            YourIdea: '',   
            svgSending: false,      
            form: {
                LogoUrl: "http://www.fasters.com.br/res/images/clientes/pontofacil.png",
                MailTo: "contato@pontofacil.com.br",
                FromName: '',
                From: '',
                Phone: '',
            },
            labelsForms: [
                {
                    label:"nomeCompleto",
                    type:"text",
                    id:"nomeCompleto",
                    content:"Digite seu <strong>Nome Completo</strong>",
                    placeholder:"Nome Completo",
                    // vmodel: this.form.FromName
                },
                {
                    label:"email",
                    type:"email",
                    id:"email",
                    content:"Digite seu <strong>E-mail</strong>",
                    placeholder:"E-mail",
                    // vmodel: this.form.From
                },
                {
                    label:"telefone",
                    type:"text",
                    id:"telefone",
                    content:"Digite seu <strong>Telefone Celular</strong> (com DDD)",
                    mask:'(##) # ####-####',
                    placeholder:"(35) 9 9999-9999",
                    // vmodel: this.form.Phone
                },
                {
                    label:"Cidade",
                    type:"text",
                    id:"Cidade",
                    content:"Qual a sua <strong>Cidade?</strong>",
                    placeholder:"Cidade",
                    // vmodel: this.city
                },
                {
                    label:"investimentoInicial",
                    type:"text",
                    id:"investimentoInicial",
                    content:"Digite <strong>Quanto pretende investir.</strong>",
                    placeholder:"Quanto pretende investir",
                    // vmodel: this.HowMutch
                },
                
            ]
        }
    },

    components:{
        PublicOpinion
    },
    
    methods: {
        catchVal(){
            this.form.FromName = $("#nomeCompleto").val();
            this.form.From = $("#email").val();
            this.form.Phone = $("#telefone").val();
            // this.Profession = $("#profissao").val();
            // this.Borned = $("#dln").val();
            this.city = $("#cidade").val();
            // this.AreABusinessperson = $("#negocioProprio").val();
            this.HowMutch = $("#investimentoInicial").val();
            // this.howDiscovery = $("#comoSoube").val();      
        },
        onSubmit() {
            this.svgSending = true;
            this.catchVal()
            this.btnText     = "Enviando...";            
            this.isBtnDisabled = true;
            this.form.message =
            "<br> <strong> Nome completo: </strong>" + this.form.FromName
            +"<br> <strong> E-mail: </strong>" + this.form.From
            +"<br> <strong> Telefone: </strong>" + this.form.Phone
            +"<br> <strong> Cidade: </strong>" + this.city
            +"<br> <strong> Quanto pretende investir? </strong>" + this.HowMutch
            // +"<br> <strong> Como ficou sabendo da Ponto Fácil? </strong>" + this.howDiscovery
            // +"<br> <strong> Sobre e a Ideia: </strong>" + this.YourIdea;
        
            this.$http
            .post("https://mail.fasters.com.br/api/send", this.form, {
            headers: {
                "Content-Type": "application/json",
            }
            })
            .then(                
            response => { //eslint-disable-line no-var, no-unused-vars
                this.$alert("Obrigado. Os seus dados foram encaminhados para nossa equipe e entraremos em contato brevemente.")
                this.btnText = "Enviar"
                return response => labelsForm
                console.log(labelsForm)
                $('#form').each (function(){
                 this.reset();
                 
                });                
                this.$ga.event({
                eventCategory: "formCur",
                eventLabel: "enviado",
                eventAction: "enviar"
                });
                (this.isBtnDisabled = false)
                this.svgSending = false
            },
            response => {
                console.log(response)
                this.$alert("Algo de errado aconteceu. Nossa equipe já está verificando. Tente novamente mais tarde.")
                this.isBtnDisabled = false
                this.btnText = "Enviar"
                $('#form').each (function(){
                 this.reset();
                }); 
                console.log(response);// eslint-disable-line no-console
                this.svgSending = false
            }
            );
        },
    },
}
</script>